import { render, staticRenderFns } from "./ModalStock.vue?vue&type=template&id=37c20fa7"
import script from "./ModalStock.vue?vue&type=script&lang=js"
export * from "./ModalStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports